<template>
  <div>
         <el-row :gutter="3">
           <el-col :span="16">
              <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="8">
                  <el-input
                    clearable
                    v-model="profitItemObject.priceStart"
                    placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  ></el-input
                ></el-col>
                <el-col :span="2">元 ~ </el-col>
                <el-col :span="8">
                  <el-input
                    clearable
                    v-model="profitItemObject.priceEnd"
                    placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  ></el-input>
                </el-col>
                <el-col :span="4">元(含)</el-col>
              </el-row>
           </el-col>
           <el-col :span="7">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                   <el-input clearable v-model="profitItemObject.price"></el-input>
                 </el-col>
              </el-row>
           </el-col>
            <!-- <el-col :span="4">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                   <el-input clearable v-model="profitItemObject.secondPrice"></el-input>
                 </el-col>
              </el-row>
           </el-col>
            <el-col :span="4">
              <el-row align="middle" type="flex" :gutter="1">
                 <el-col :span="24">
                   <el-input clearable v-model="profitItemObject.thirdPrice"></el-input>
                 </el-col>
              </el-row>
           </el-col> -->
           <el-col :span="1">
            <el-button
                  style="marginLeft:5px"
                  icon="el-icon-delete"
                  @click="deleteProfitItem()"
                ></el-button>
           </el-col>
         </el-row>
  </div>
</template>

<script>
export default {
  name: "profitItem",
  components: {},
  props: [
    "profitItemObject",
    "itemIndex",
  ],
  data() {
    return {
    };
  },
  watch: {
  },
  computed: {},
  methods: {
    deleteProfitItem(){
       this.$emit(
        "deleteProfitItem",
        this.$props.itemIndex
      );
    },
  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="less" scoped></style>
